export default __webpack_public_path__ + "static/media/animateLogo.d3a03973.svg";